// useElectron.js — React hook that safely uses the Electron bridge
// When running in a browser (not Electron), all calls are no-ops.

const el = typeof window !== "undefined" && window.electron ? window.electron : null;

export const isElectron = !!el;
export const platform = el?.platform || "web";

export function useElectron() {
  return {
    isElectron,
    platform,

    // Send a native notification (no-op in browser)
    notify: (title, body, silent) => {
      if (el) {
        el.notify(title, body, silent);
      } else if ("Notification" in window && Notification.permission === "granted") {
        new Notification(title, { body, silent });
      }
    },

    // Update taskbar/dock unread badge
    setBadge: (count) => el?.setBadge(count),

    // Window controls (custom titlebar on Windows Electron)
    minimize: () => el?.minimize(),
    maximize: () => el?.maximize(),
    close:    () => el?.close(),

    // Auto updater callbacks
    onUpdateAvailable:  (cb) => el?.onUpdateAvailable(cb),
    onUpdateDownloaded: (cb) => el?.onUpdateDownloaded(cb),
    installUpdate:      ()   => el?.installUpdate(),
  };
}
